import React from "react";
import { Route, Redirect } from "react-router-dom";
import DashboardConsolidado from "../Components/Educacao/DashboardConsolidado";
import Index from "../pages/Educacao/Index";
import PageEducacao from "../pages/Educacao/PageEducacao";
import PageMetas from "../pages/Educacao/Metas";
import PageMetasMensais from "../pages/Educacao/MetasMensais";
import PageDashboard from "../pages/Educacao/Dashboard";
import FormCadastroCurso from "../Components/Educacao/Metas/FormCadastraCurso";

import Profile from "../Components/Auth/Pages/profile.component";

// Rotas do domínio Educação. Exporta só a lista de elementos <Route>/<Redirect>
// (sem <BrowserRouter>/<Switch> próprios) para serem montadas dentro do único
// <Switch> consolidado em pages/Principal/index.js (Fase 5).
//
// /grafico, /cursos, /relatorios, /exportacao, /treemap e /bi foram removidas
// (Fase 15 do Dashboard Consolidado — telas substituídas pelo novo dashboard,
// a pedido do usuário; /bi também confirmado sem uso). Os componentes de
// seletor que o Dashboard Consolidado (FiltroBar) e as telas /dashboard ainda
// reaproveitam (Relatorio/Grafico/Select, Radio, SelectCampo; Relatorio/Cursos/
// SelectCampo, SelectTipo) permaneceram no lugar.
const routesEducacao = [
    <Route key="educacao-home" exact path="/" render={() => (<Redirect to="/dashboard" />)} />,
    <Route key="educacao-educacao" exact path="/educacao" component={PageEducacao} />,
    <Route key="educacao-unidade" exact path="/unidade" component={Index} />,
    <Route key="educacao-unidade-detalhe" exact path="/unidade/:unidade" component={PageMetas} />,
    <Route key="educacao-unidade-mensais" exact path="/unidade/:unidade/mensais-:_id" component={PageMetasMensais} />,
    <Route key="educacao-dashboard" exact path="/dashboard" component={PageDashboard} />,
    <Route key="educacao-novocurso" exact path="/novocurso" component={FormCadastroCurso} />,
    <Route key="educacao-profile" exact path="/profile" component={Profile} />,
    <Route key="educacao-dashboard-consolidado" exact path="/dashboardconsolidado" component={DashboardConsolidado} />
];

export default routesEducacao;
